import { css } from "styled-components";

export const miscStyles = css`
  .grecaptcha-badge {
    visibility: hidden;
  }
`;
